export default {
  'stock.DeliveryOdMaterial.form.selectReportType': 'Select the Report Type',
  'stock.DeliveryOdMaterial.form.selectReportType.delivery': 'Delivery',
  'stock.DeliveryOdMaterial.form.selectReportType.return': 'Return',
  'stock.DeliveryOdMaterial.form.selectReportType.employeesVsInputs':
    'employees Vs Inputs',
  'stock.DeliveryOdMaterial.form.employeesVsInputs':
    'Show stockist or employees on printed items?',
  'stock.DeliveryOdMaterial.form.selectReportType': 'Select Report Type',
  'stock.DeliveryOdMaterial.form.selectReportType.closing': 'Closing',
  'stock.DeliveryOdMaterial.form.selectReportType.deliveryReturn':
    'delivery/Return',
  'stock.DeliveryOdMaterial.form.stockGroupReportBy': 'Stock Group Report By',
  'stock.DeliveryOdMaterial.form.stockGroupReportBy.date': 'Date',
  'stock.DeliveryOdMaterial.form.stockGroupReportBy.employee': 'Employee',
  'stock.DeliveryOdMaterial.form.type': 'Type',
  'stock.DeliveryOdMaterial.form.type.info':
    'When "Esto" is selected, the "Delivery" report will filter who is receiving the material/input and the "Return" and "Employees x Inputs" reports will filter who is receiving what they are receiving. When "Employee" is selected, the filter will be the inverse of who receives/who delivers.',
  'stock.DeliveryOdMaterial.form.type.stockist': 'Stockist',
  'stock.DeliveryOdMaterial.form.type.employee': 'Employee',

  'stock.DeliveryOdMaterial.form.moreOptions': 'More Options',
  'stock.DeliveryOdMaterial.form.moreOptions.filterByBudget':
    'Filter By Budget',
  'stock.DeliveryOdMaterial.form.moreOptions.employees': 'Employees',
};
